<template>
  <div class="order-delivery-form">
    <div class="form-header c:row-between-center">
      <div class="form-title">取货方式</div>
      <div class="delivery-type">
        <c-switch
          v-model="deliveryMethod"
          :unchecked-value="0"
          unchecked-text="邮寄"
          :checked-value="1"
          checked-text="自提"
          @change="validate"
        />
      </div>
    </div>
    <div class="form-divider"></div>
    <div v-if="deliveryMethod === 1" class="pickup-info">
      <div class="store-name">{{ order.pickupStoreVo?.name || "" }}</div>
      <div class="store-address">
        {{ pickupAddress }}
      </div>
    </div>
    <div v-else class="delivery-form">
      <div class="form-helper c:row-between-center">
        <div class="form-label">收货地址</div>
        <div
          class="import-from-wechat c:row-end-start"
          @click="throttledOnImportAddFromWeChatClick"
        >
          <img src="@/assets/icons/wechat.svg" alt="" />
          <span>一键导入微信地址</span>
        </div>
      </div>

      <div class="form-items c:col-center">
        <div class="form-item-group c:row-between-center">
          <div class="form-item">
            <CSelect
              title="称谓"
              placeholder="称谓"
              v-model="titleIndex"
              :options="titleOptions"
            />
          </div>
          <div class="form-item flex-2">
            <CInput placeholder="姓名" v-model="userName" @change="validate" />
          </div>
        </div>
        <div class="form-item">
          <CInput
            placeholder="手机号码"
            type="number"
            v-model="telNumber"
            @change="validate"
          />
        </div>
        <div class="form-item-group c:row-between-center">
          <div class="form-item">
            <CSelect
              title="省份"
              placeholder="省份"
              v-model="provinceIndex"
              :options="provinceOptions"
              @change="onProvinceSelect"
            />
          </div>
          <div class="form-item">
            <CSelect
              title="城市"
              placeholder="城市"
              v-model="cityIndex"
              :options="cityOptions"
              @change="onCitySelect"
            />
          </div>
        </div>
        <div class="form-item">
          <CSelect
            title="区/县"
            placeholder="区/县"
            v-model="countyIndex"
            :options="countyOptions"
            @change="validate"
          />
        </div>
        <div class="form-item">
          <CInput
            v-model="detailInfo"
            placeholder="详细地址"
            @change="validate"
          />
        </div>
      </div>
    </div>
    <CConfirm ref="refCConfirm" />
  </div>
</template>

<script>
import CConfirm from "@/components/common/CConfirm.vue";
import CInput from "@/components/common/CInput.vue";
import CSelect from "@/components/common/CSelect.vue";
import CSwitch from "@/components/common/CSwitch.vue";
import regions from "@/consts/regions";
import { openAddress, throttle } from "@/utils";

const emojiRegex =
  /[\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}|\u{1F900}-\u{1F9FF}|\u{1F004}|\u{1F0CF}|\u{1F170}-\u{1F1FF}|\u{1F1E6}-\u{1F1FF}|\u{1F201}-\u{1F202}|\u{1F21A}-\u{1F23B}|\u{1F24C}-\u{1F251}|\u{1F260}-\u{1F265}|\u{1F300}-\u{1F5FF}|\u{1F600}-\u{1F64F}|\u{1F680}-\u{1F6FF}|\u{1F900}-\u{1F9FF}|\u{1F004}|\u{1F0CF}|\u{1F170}-\u{1F1FF}|\u{1F1E6}-\u{1F1FF}|\u{1F201}-\u{1F202}|\u{1F21A}-\u{1F23B}|\u{1F24C}-\u{1F251}|\u{1F260}-\u{1F265}|\u{1F900}-\u{1F9FF}]/u;
const phoneRegex = /^\+?[1-9]\d{1,14}$/;

export default {
  components: {
    CSwitch,
    CSelect,
    CInput,
    CConfirm,
  },
  props: {
    role: String,
    order: Object,
  },
  watch: {
    "order.address": {
      deep: true,
      handler() {
        this.assignOrderAddress();
      },
    },
  },
  data() {
    return {
      deliveryMethod: 0, // [{ code: 0, desc: "物流发货", }, { code: 1, desc: "客户自提",}],
      titleOptions: [{ label: "先生" }, { label: "女士" }],
      titleIndex: undefined,
      userName: "",
      telNumber: "",
      provinceOptions: [],
      provinceIndex: undefined,
      cityOptions: [],
      cityIndex: undefined,
      countyOptions: [],
      countyIndex: undefined,
      detailInfo: "",
      validation: { error: "", checked: false },
    };
  },
  created() {
    this.throttledOnImportAddFromWeChatClick = throttle(
      this.importAddFromWeChat,
      500
    );
  },
  computed: {
    pickupAddress() {
      if (this.order.pickupStoreVo) {
        const { province, city, countyName, address } =
          this.order.pickupStoreVo;
        return `${province || ""}${city || ""}${countyName || ""}${
          address || ""
        }`;
      }
      return "";
    },
  },
  mounted() {
    this.initProvinceOptions();
    this.assignOrderAddress();
    this.validate();
  },
  // expose: ["submit"], 不支持
  methods: {
    initProvinceOptions() {
      this.provinceOptions = regions.map((region) => ({
        value: region, // region.code,
        label: region.name,
      }));
    },
    updateCityOptions(province) {
      this.cityOptions = province.citys.map((city) => ({
        value: city, // c.code,
        label: city.name,
      }));
      this.cityIndex = 0;
      this.updateDistrictOptions(this.cityOptions[this.cityIndex].value);
    },
    updateDistrictOptions(city) {
      console.log("updateDistrictOptions", city);
      this.countyOptions = city.areas.map((area) => ({
        value: area, // c.code,
        label: area.name,
      }));
      this.countyIndex = 0;
    },
    assignOrderAddress() {
      console.log("order.address", this.order.addressVo);
      if (this.order.addressVo) {
        const { userName, telNumber, detailInfo } = this.order.addressVo;

        this.userName = userName;
        this.telNumber = telNumber;
        if (this.assignCityInfo(this.order.addressVo)) {
          this.detailInfo = detailInfo;
        }
        this.validate();
      }
    },
    assignWxAddress(addr) {
      console.log("assignWxAddress", addr);

      this.userName = addr.userName;
      this.telNumber = addr.telNumber;
      if (this.assignCityInfo({ ...addr, countyName: addr.countryName })) {
        this.detailInfo = addr.detailInfo
          ? addr.detailInfo
          : addr.addressStreetFourthStageName + addr.addressDetailInfoNew;
      }
      this.validate();
    },
    assignCityInfo(addr) {
      const provinceIndex = this.provinceOptions.findIndex(
        (province) =>
          addr?.provinceName?.includes(province.label) ||
          province.label.includes(addr?.provinceName)
      );
      if (provinceIndex > -1) {
        this.provinceIndex = provinceIndex;
        this.updateCityOptions(this.provinceOptions[provinceIndex].value);
        const cityIndex = this.cityOptions.findIndex(
          (city) =>
            addr?.cityName?.includes(city.label) ||
            city.label.includes(addr?.cityName)
        );

        if (cityIndex > -1) {
          this.cityIndex = cityIndex;
          this.updateDistrictOptions(this.cityOptions[cityIndex].value);
          const countyIndex = this.countyOptions.findIndex(
            (countyName) =>
              addr?.countyName?.includes(countyName.label) ||
              countyName.label.includes(addr?.countyName)
          );
          if (cityIndex > -1) {
            this.countyIndex = countyIndex;
            return true;
          } else {
            this.countyIndex = undefined;
          }
        } else {
          this.cityIndex = undefined;
          this.countyIndex = undefined;
        }
      } else {
        this.provinceIndex = undefined;
        this.cityIndex = undefined;
        this.countyIndex = undefined;
        this.cityOptions = [];
      }
      return false;
    },
    async importAddFromWeChat() {
      try {
        await this.$refs.refCConfirm.show("需要访问您的微信地址");
        const res = await openAddress();
        await this.$refs.refCConfirm.show("确定选择该地址？");
        this.assignWxAddress(res);
      } catch (error) {
        console.log("importAddFromWeChat error", error);
        if (error?.message) this.$toast(error.message);
      }
    },

    validate() {
      let error = "";
      let checked = true;
      if (this.deliveryMethod === 0) {
        checked = [
          "userName",
          "telNumber",
          "provinceIndex",
          "cityIndex",
          "countyIndex",
          "detailInfo",
        ].every((key) => {
          if (["userName", "detailInfo"].includes(key)) {
            const { errMsg, checked } = this.validateForDetail(key);
            error = errMsg;
            return checked;
          }
          if (["telNumber"].includes(key)) {
            const { errMsg, checked } = this.validateForPhone(key);
            error = errMsg;
            return checked;
          }
          if (["provinceIndex", "cityIndex", "countyIndex"].includes(key)) {
            const { errMsg, checked } = this.validateForCity(key);
            error = errMsg;
            return checked;
          }

          return true;
        });
      }
      this.validation = {
        error,
        checked,
      };
      this.$emit("validate", this.validation);
    },
    validateForDetail(key) {
      if (this[key] && this[key].trim()) {
        return { errMsg: "", checked: true };
      } else {
        return { errMsg: `${key} is required`, checked: false };
      }
    },
    validateForPhone(key) {
      if (this[key] && this[key].trim()) {
        const telNumber = this[key];
        if (!/^\d+$/.test(telNumber)) {
          return { errMsg: `${key} must be numbers`, checked: false };
        }
        // if (telNumber.length !== 11) {
        //   return { errMsg: `${key} must be 11 digits`, checked: false };
        // }
        return { errMsg: "", checked: true };
      }

      return { errMsg: `${key} is required`, checked: false };
    },
    validateForCity(key) {
      if (this[key] === undefined) {
        return {
          errMsg: `${key.replace("Index", "")} is required`,
          checked: false,
        };
      }

      return { errMsg: "", checked: true };
    },
    getFormData() {
      let {
        deliveryMethod,
        titleIndex,
        userName,
        telNumber,
        provinceIndex,
        cityIndex,
        countyIndex,
        detailInfo: detailInfo,
      } = this;
      if (deliveryMethod === 1) {
        return {
          deliveryMethod,
          address: {
            userName: "",
            telNumber: "",
            provinceName: "",
            cityName: "",
            countyName: "",
            detailInfo: "",
          },
        };
      }

      if (emojiRegex.test(userName)) {
        throw { message: "用户名不能含有表情" };
      }
      if (!phoneRegex.test(telNumber)) {
        return this.$toast("手机号码格式不正确");
      }
      if (emojiRegex.test(detailInfo)) {
        throw { message: "详细地址不能含有表情" };
      }

      if (titleIndex !== undefined) {
        userName += this.titleOptions[titleIndex].label;
      }
      const provinceName = this.provinceOptions[provinceIndex].label;
      const cityName = this.cityOptions[cityIndex].label;
      const countyName = this.countyOptions[countyIndex].label;

      return {
        deliveryMethod,
        address: {
          userName,
          telNumber,
          provinceName,
          cityName,
          countyName,
          detailInfo,
        },
      };
    },
    onProvinceSelect(_, province) {
      console.log("onProvinceSelect", _, province);
      this.updateCityOptions(province.value);
      this.validate();
    },
    onCitySelect(_, city) {
      console.log("onCitySelect", _, city);
      this.updateDistrictOptions(city.value);
      this.validate();
    },
  },
};
</script>

<style lang="less" scoped>
.order-delivery-form {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  padding: 16/20rem 0;
  background: #f7f7f7;

  .form-header {
    width: 100%;
    height: 25/20rem;
    margin-bottom: 17/20rem;

    .form-title {
      line-height: 18/20rem;
      font-size: 12/20rem;
      font-weight: 400;
      letter-spacing: 0;
    }
  }

  .form-divider {
    width: 100%;
    height: 1/20rem;
    background: #e9e9eb;
  }

  .pickup-info {
    margin-top: 20/20rem;

    .store-name {
      height: 13/20rem;
      line-height: 13/20rem;
      font-size: 13/20rem;
      font-weight: 500;
      letter-spacing: 0;
    }

    .store-address {
      margin-top: 10/20rem;
      line-height: 17/20rem;
      font-size: 12/20rem;
      font-weight: 400;
      letter-spacing: 0;
      text-align: justify;
    }
  }

  .delivery-form {
    .form-helper {
      width: 100%;
      height: 16/20rem;
      margin-top: 19/20rem;
      margin-bottom: 19/20rem;

      line-height: 14/20rem;
      font-size: 12/20rem;
      font-weight: 400;
      letter-spacing: 0;

      .form-label {
        height: 16/20rem;
      }

      .import-from-wechat {
        gap: 5/20rem;

        height: 16/20rem;

        text-align: right;
        text-decoration: underline;
        text-decoration-style: solid;
        text-decoration-thickness: 0%;

        img {
          width: 19/20rem;
          height: 16/20rem;
        }
      }
    }
  }

  .form-items {
    gap: 10/20rem;

    width: 100%;
    .form-item-group {
      gap: 9/20rem;

      width: 100%;
      .form-item {
        flex: 1;
        width: 0;

        &.flex-2 {
          flex: 2;
        }
      }
    }

    .form-item {
      width: 100%;
      height: 40/20rem;
    }
  }
}
</style>
